import React from 'react';
import PopupRows from "./PopupRows";
import FirstPopupRow from "./FirstPopupRow";
import "./Component.css";

const getVersionUrl = "/getVersions/";

const PopupButton = (props) => {

    let versionHistory = [];
    let versionRows = [];

    const getData = async (callback) => {
        let url = getVersionUrl + props.clientId;
        const response = await fetch(url);
        const body = await response.json();
        if (response.status !== 200) throw Error(body.message);
        versionHistory = body;
        callback(); 
    };

    const showData = () => {
        getRows();
        props.updateModalStates(true,versionRows)
    };

    const getRows = () => {
        versionRows = [];
        if (versionHistory != null && versionHistory.length>0) {
            versionRows.push(
                <FirstPopupRow
                    definition={versionHistory[0]}
                />
            );
            for (let i = 1; i < versionHistory.length; i++) {
                versionRows.push(
                    <PopupRows
                        definition={versionHistory[i]}
                    />
                );
            }
        } else {
            let latestVersion ;
            latestVersion = {
                "openapi_json": props.latestOpenApi,
                "postmanCollection": props.latestPostmanCollection,
                "update_version": "-",
                "created_by": props.uploadedBy,
                "created_on": props.uploadedOn
            };
            versionRows.push(
                <FirstPopupRow
                    definition={latestVersion}
                />
            );
        }
    };


    const handleShow = () => {
        getData(showData);    
    };
    
    return (
        <div>
        <button onClick={handleShow} className='version theme-color'>
                Versions
        </button>
        </div>
    )
}

export default PopupButton
